<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id" style="    display: inline-block;
    float: left;
    margin-right: 20px;
    padding-top: 4px;">
      {{ props.label }}:
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }
  <div >
    <div style="display: flex;  flex-wrap: wrap;">
      <nb-radio [id]="id + '_' + 0"
                [checked]="isCheckedAll()"
                [formlyAttributes]="field" (valueChange)="onChange(0, $event)">
       All
      </nb-radio>
      @for (option of $any(props.options); track option.value; let i = $index) {
        <div class="me-3">
          <nb-radio [id]="id + '_' + i"
                       [checked]="isChecked(option)"
                       [formlyAttributes]="field" (valueChange)="onChange(option.value, $event)">
            {{ option.label }}  ({{ (option.count>0)?option.count:0 }})
          </nb-radio>
        </div>
      }
    </div>
  </div>
  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
